module.exports = __webpack_public_path__ + "static/media/banner2.eeda7327.png";